import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { FactoryNavigationBar } from '../component/navigation-bar/FactoryNavigationBar';
import { ServiceTokenDiv } from '../component/service-token/ServiceTokenDiv';

export const ServiceTokenPage = () => (
  <MainPageLayout
    navigationBar={<FactoryNavigationBar />}
    elementCentr={<ServiceTokenDiv />}
  />
);
